<mat-dialog-content>
    <div class="hypo-dialog-header">
        <div class="hypo-dialog-title">Ověření telefonního čísla</div>
    </div>

    <div class="hypo-dialog-content" [attr.data-testid]="'verify-phone-dialog'">
        @if (isVerified) {
            <p>Děkujeme. Vaše telefonní číslo bylo úspěšně ověřeno.</p>
            <div class="hypo-dialog-footer mb-4 flex flex-row items-center justify-center">
                <button
                    type="button"
                    mat-raised-button
                    color="primary"
                    [attr.data-testid]="'verify-phone-dialog-button-ok'"
                    (click)="close()">
                    OK
                </button>
            </div>
        }

        @if (!isVerified) {
            <p>Na váš telefon byla odeslána zpráva s ověřovacím kódem.</p>
            <div class="input-label">Zadejte ověřovací kód</div>
            <div class="form-row">
                <mat-form-field floatLabel="always">
                    <input
                        matInput
                        autocapitalize="off"
                        [(ngModel)]="code"
                        [attr.data-testid]="'verify-phone-dialog-code'" />
                </mat-form-field>
            </div>
            <div class="hypo-dialog-footer mb-4 flex flex-row items-center justify-center">
                <button
                    type="button"
                    mat-button
                    color="warn"
                    [attr.data-testid]="'verify-phone-dialog-button-cancel'"
                    (click)="close()">
                    Zrušit
                </button>
                <button
                    type="button"
                    mat-raised-button
                    color="primary"
                    (click)="verify()"
                    [attr.data-testid]="'verify-phone-dialog-button-ok'"
                    [disabled]="!code">
                    Potvrdit
                </button>
            </div>
        }
    </div>
</mat-dialog-content>
